module.exports = __webpack_public_path__ + "onboarding-pkg.df69e82259301621d7f559428738473b.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/img/library/empty/onboarding-pkg.svg
// module id = 8668901059265862
// module chunks = 1